// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"169ca1dc","80":"2e82545b","292":"10217236","334":"ba82b9ee","405":"bbd0a850","477":"6405c072","761":"f1ec6e45","880":"51e92573","924":"a448b39f","934":"047b327f"}[chunkId] + ".chunk.js";
};